export const errerMessages = {
  CANNOT_PROCESS_PAYMENT:
    'Sorry, your payment cannot be processed at the moment',
  KOUNT_FAILED_ERROR: 'Payment failed due to incorrect card details. Please verify your card information and try again.',
  SOMETHING_WENT_WRONG: 'Something went wrong',
  PAYMENT_DECLINED_FOR_SECURITY_REASONS: 'Payment failed',
  ERROR_REQUEST_MSG: (id) =>
    `Your payment for order #${id} was not completed. If an amount was debited, it will be refunded to your card with 3 to 5 working days.`,
};
export const spinnerMessage = {
  REDIRECT_MESSAGE: 'Please wait...',
  LOADING: 'Loading...',
  ORDER_ALRDY_PROCESSED:
    'Order already processed. Redirecting you to the success page.',
};
export const delayMessage = {
  LONG_DELAY_MESSAGE:
    'oops, taking longer than expected, hold on. Payment will be succedeed.',
};

export const orderIdLabel = {
  ORDER_ID: 'Order ID',
  REFERENCE: 'Reference',
};

export const ORDER_ID_VERSION_SUFFIX = '-V01';

export const getVersionedOrderId = (orderId) => `${orderId}${ORDER_ID_VERSION_SUFFIX}`;

export const buttonTxts = {
  TRY_AGAIN: 'Try again',
  CANCEL: 'Cancel',
};
